import { useCallback, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { HistoryList } from "@/components/network/HistoryDialog";
import { SELECT_CLS } from "@/lib/network";

// Jalur B — khusus Admin. Menulis ke koleksi penempatan yang sama dengan Master ODP.
export function CustomerOdpSection({ customerId }) {
  const [info, setInfo] = useState(null);
  const [odcs, setOdcs] = useState([]);
  const [odps, setOdps] = useState([]);
  const [ports, setPorts] = useState([]);
  const [sel, setSel] = useState({ odc: "", odp: "", port: "" });
  const [busy, setBusy] = useState(false);
  const [showHist, setShowHist] = useState(false);
  const load = useCallback(() => api.get(`/network/customers/${customerId}/placement`).then((r) => setInfo(r.data)), [customerId]);
  useEffect(() => { load(); api.get("/network/odc").then((r) => setOdcs(r.data)); }, [load]);
  useEffect(() => {
    setOdps([]); setSel((s) => ({ ...s, odp: "", port: "" }));
    if (sel.odc) api.get("/network/odp", { params: { odc_id: sel.odc, status: "AKTIF" } }).then((r) => setOdps(r.data));
  }, [sel.odc]);
  useEffect(() => {
    setPorts([]); setSel((s) => ({ ...s, port: "" }));
    if (sel.odp) api.get(`/network/odp/${sel.odp}`).then((r) => setPorts(r.data.ports.filter((p) => !p.customer_id)));
  }, [sel.odp]);
  const cur = info?.current;
  const save = async () => {
    setBusy(true);
    try {
      await api.post(cur ? "/network/placements/move" : "/network/placements", { customer_id: customerId, odp_id: sel.odp, port: Number(sel.port) });
      toast.success(cur ? "Penempatan ODP dipindahkan" : "Penempatan ODP tersimpan");
      setSel({ odc: "", odp: "", port: "" });
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Gagal menyimpan");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-2 rounded-md border border-[#BFDBFE] bg-[#F8FBFF] p-3" data-testid="cust-odp-section">
      <div className="flex items-center justify-between">
        <Label className="font-bold">Penempatan Jaringan / ODP</Label>
        <Button type="button" size="sm" variant="ghost" onClick={() => setShowHist((v) => !v)} data-testid="cust-odp-history-toggle">Riwayat</Button>
      </div>
      {info && !info.customer_wilayah_id && <p className="text-xs text-[#B45309]">Pelanggan belum memiliki wilayah Billing, sehingga belum dapat ditempatkan.</p>}
      <p className="text-xs" data-testid="cust-odp-current">
        {!info ? "Memuat…" : cur ? <>Saat ini: <b>{cur.odc?.kode}</b> → <b>{cur.odp?.kode}</b> port <b>{cur.port}</b></>
          : <span className="text-[#6B7280]">Belum ditempatkan ke ODP (boleh dikosongkan).</span>}
      </p>
      <div className="grid grid-cols-3 gap-2">
        <select className={SELECT_CLS} value={sel.odc} onChange={(e) => setSel({ odc: e.target.value, odp: "", port: "" })} data-testid="cust-odp-odc">
          <option value="">ODC…</option>{odcs.filter((o) => !info?.customer_wilayah_id || o.wilayah_id === info.customer_wilayah_id).map((o) => <option key={o.id} value={o.id}>{o.kode}</option>)}</select>
        <select className={SELECT_CLS} value={sel.odp} disabled={!sel.odc} onChange={(e) => setSel((s) => ({ ...s, odp: e.target.value }))} data-testid="cust-odp-odp">
          <option value="">ODP…</option>{odps.map((o) => <option key={o.id} value={o.id}>{o.kode} ({o.port_kosong} kosong)</option>)}</select>
        <select className={SELECT_CLS} value={sel.port} disabled={!sel.odp} onChange={(e) => setSel((s) => ({ ...s, port: e.target.value }))} data-testid="cust-odp-port">
          <option value="">Port…</option>{ports.map((p) => <option key={p.port} value={p.port}>Port {p.port}</option>)}</select>
      </div>
      <div className="flex justify-end">
        <Button type="button" size="sm" disabled={busy || !sel.port} onClick={save} data-testid="cust-odp-save">
          {cur ? "Pindahkan ke Port Ini" : "Simpan Penempatan"}</Button>
      </div>
      {showHist && <HistoryList items={info?.history} testid="cust-odp-history" />}
    </div>
  );
}
